import http from "../httpService";


class MobilePosService {
  async getProductBanners(input) {
    const result = await http.get('api/services/app/MobilePos/GetProductBanners',{
      params: input,
    });
    
    return result.data.result;
  }

  async getProductGroups(input) {
    const result = await http.get('api/services/app/MobilePos/GetProductGroups',{
      params: input,
    });
    
    return result.data.result;
  }

  async getProducts(input) {
    const result = await http.get('api/services/app/MobilePos/GetProducts',{
      params: input,
    });

    return result.data.result;
  }
}

export default MobilePosService = new MobilePosService();
